module.exports = __webpack_public_path__ + "static/img/h-logo.5c8b852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h-logo.png
// module id = 9/Ah
// module chunks = 13